import { render, staticRenderFns } from "./UiButton.vue?vue&type=template&id=16d7dae4&scoped=true&"
import script from "./UiButton.vue?vue&type=script&lang=js&"
export * from "./UiButton.vue?vue&type=script&lang=js&"
import style0 from "./UiButton.vue?vue&type=style&index=0&id=16d7dae4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16d7dae4",
  null
  
)

export default component.exports